import React, { useRef } from "react";
import {
  makeStyles,
  Typography,
  Paper,
  ClickAwayListener,
  Box,
  Divider,
  InputAdornment,
  Button,
  MenuItem,
  MenuList,
  Popover,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputTextField from "components/input/inputTextField";
import clsx from "clsx";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  paper: {
    width: 375,
  },
  button: {
    padding: theme.spacing(1),
    minWidth: 0,
  },
  buttonAddWarranty: {
    display: "flex",
    padding: 0,
    minWidth: 0,
  },
  createLink: {
    padding: theme.spacing(2),
  },
  menuListContainer: {
    maxHeight: "28px",
  },
  menuListOdd: {
    backgroundColor: "#f8f8f8",
  },
  scroll: {
    overflowY: "auto",
    maxHeight: "250px",
  },
  emptyContainer: {
    backgroundColor: theme.palette.common.white,
    textAlign: "center",
  },
  menuItemContainer: {
    flexFlow: "column",
    placeItems: "flex-start",
  },
  errorContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
}));

export default function SetWinnerPanelComponent({
  anchorEl,
  isOpen,
  handleClose,
  handleListKeyDown,
  isFetching,
  value,
  serialNumberData,
  excludeList,
  handleFetchMoreItems,
  handleSearch,
  lang,
  totalRecords,
  isError,
  handleReload,
}) {
  const classes = useStyle();
  const textRef = useRef();

  let excludeEncs = excludeList.map((e) => e.enc);

  let dataList = excludeList.length
    ? serialNumberData.filter((s) => !excludeEncs.includes(s.enc))
    : serialNumberData;

  return (
    <Popover
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Paper className={classes.paper}>
        <ClickAwayListener onClickAway={handleClose}>
          <Box>
            <Box>
              <InputTextField
                inputRef={textRef}
                variant="filled"
                size="small"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ paddingRight: "6px" }}
                    >
                      <Button
                        type="button"
                        className={classes.button}
                        onClick={() => handleSearch(textRef.current.value)}
                      >
                        <SearchIcon fontSize="small" />
                      </Button>
                    </InputAdornment>
                  ),
                  style: {
                    backgroundColor: "#fff",
                  },
                }}
                inputProps={{
                  onKeyDown: (e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch(textRef.current.value);
                      return false;
                    }
                  },
                  style: {
                    padding: "14px",
                  },
                }}
                placeholder={getLang(
                  lang,
                  "placeholder.ENTER_SERIAL_NUMBER_HERE"
                )}
              />
            </Box>

            <Divider />
            {!!isError ? (
              <Box py={1.5} px={2} className={classes.errorContainer}>
                <Typography
                  variant="body2"
                  style={{
                    color: "#9CA6A9",
                    paddingBottom: "16px",
                  }}
                >
                  {getLang(lang, "paragraph.SOMETHING_WENT_WRONG")}
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleReload}
                  disableElevation
                >
                  {getLang(lang, "label.RETRY")}
                </Button>
              </Box>
            ) : (
              <InfiniteScroll
                dataLength={serialNumberData.length}
                next={handleFetchMoreItems}
                hasMore={serialNumberData.length < totalRecords}
                loader={
                  <Box my={2}>
                    <LoadingComponent height={50} />
                  </Box>
                }
                height={200}
                style={{ position: "relative" }}
                endMessage={
                  isFetching ? (
                    <Box my={2}>
                      <LoadingComponent height={100} />
                    </Box>
                  ) : !serialNumberData.length ? (
                    <Box px={1.5} py={4}>
                      <Typography
                        variant="body2"
                        style={{ textAlign: "center" }}
                      >
                        <b>{getLang(lang, "paragraph.NO_SERIAL_NUMBER")}</b>
                      </Typography>
                    </Box>
                  ) : null
                }
              >
                <>
                  {dataList.map((field, index) => {
                    return (
                      <React.Fragment key={index}>
                        <MenuList
                          id="menu-list-grow"
                          onClick={() => {
                            handleListKeyDown(field.serialNumber, field.enc);
                          }}
                          className={clsx({
                            [classes.menuListOdd]: index % 2 === 0,
                            [classes.menuItemContainer]: true,
                          })}
                        >
                          <MenuItem className={classes.menuItemContainer}>
                            <Typography
                              variant="body2"
                              color="primary"
                              style={{
                                paddingLeft: "8px",
                                fontWeight: "bold",
                              }}
                            >
                              {field.serialNumber}
                            </Typography>
                          </MenuItem>
                        </MenuList>
                      </React.Fragment>
                    );
                  })}
                </>
              </InfiniteScroll>
            )}
          </Box>
        </ClickAwayListener>
      </Paper>
    </Popover>
  );
}
